module.exports = __webpack_public_path__ + "static/media/01A.23af4051.png";